import Link from 'next/link'

export default function DataPortals() {
  const portals = [
    {
      title: "United States Government Open Data Portal",
      image: "/assets/images/data-portals/data-gov/capture0.png",
      href: "/showcase/data-portals/data-gov",
      description: "Government Open Data Portal",
    },
    {
      title: "US Department of Education Open Data Platform",
      image: "/assets/images/pages/data-portals/dept-ed.webp",
      href: "/showcase/data-portals/us-department-of-education",
      description: "Government Open Data Portal",
    },
    {
      title: "United Kingdom National Government Data Portal",
      image: "/assets/images/pages/data-portals/data.gov_.uk_-1024x467.png",
      href: "/showcase/data-portals/data-gov-uk",
      description: "Government Open Data Portal",
    },
    {
      title: "European Union Open Data Portal",
      image: "/assets/images/pages/data-portals/dataeuropa.webp",
      href: "/showcase/data-portals/eu-open-data",
      description: "Government Open Data Portal",
    },
    {
      title: "Humanitarian Data Exchange",
      image: "/assets/images/pages/data-portals/hdx.webp",
      href: "/showcase/data-portals/humanitarian-data-exchange",
      description: "Health Open Data Portal",
    },
    {
      title: "Energy Data Portal",
      image: "/assets/images/pages/data-portals/energidataportal.dk_-1024x467.png",
      href: "/showcase/data-portals/energy-data-portal",
      description: "Energy Open Data Portal",
    },
    {
      title: "National Grid ESO Data Portal",
      image: "/assets/images/pages/data-portals/national-grid.webp",
      href: "/showcase/data-portals/national-grid-eso",
      description: "Energy Open Data Portal",
    },
    {
      title: "Northern Ireland Open Data Portal",
      image: "/assets/images/data-portals/open-data-northern-ireland/capture0.webp",
      href: "/showcase/data-portals/open-data-northern-ireland",
      description: "Government Open Data Portal",
    },
    {
      title: "Open Data Denmark",
      image: "/assets/images/pages/data-portals/opendata.dk_-1024x468.png",
      href: "/showcase/data-portals/open-data-denmark",
      description: "Government Open Data Portal",
    },
    {
      title: "UAE Open Data Portal",
      image: "/assets/images/layout/fcsc_bsh.jpg",
      href: "/showcase/data-portals/uae-open-data",
      description: "Government Open Data Portal",
    },
    {
      title: "MOEI",
      image: "/assets/images/data-portals/moei/moei1.png",
      href: "/showcase/data-portals/moei",
      description: "Government Open Data Portal",
    },
    {
      title: "SSEN",
      image: "/assets/images/data-portals/ssen/ssen1.png",
      href: "/showcase/data-portals/ssen",
      description: "Energy Open Data Portal",
    },
    {
      title: "Marcus Institute",
      image: "/assets/images/data-portals/marcus-institute/marcus-3.png",
      href: "/showcase/data-portals/marcus-institute",
      description: "Open Data Portal",
    },
    {
      title: "Vital Strategies",
      image: "/assets/images/data-portals/vitals/vitals1.png",
      href: "/showcase/data-portals/vital-strategies",
      description: "Health Open Data Portal",
    },
    {
      title: "UBDC",
      image: "/assets/images/data-portals/ubdc/ubdc1.png",
      href: "/showcase/data-portals/ubdc",
      description: "Data Catalog",
    },
    {
      title: "Teach for Canada",
      image: "/assets/images/data-portals/teach-for-canada/teachforcanada1.png",
      href: "/showcase/data-portals/teach-for-canada",
      description: "Internal Data Portal",
    },
    {
      title: "Government of Yukon",
      image: "/assets/images/data-portals/government-yukon/yukon1.png",
      href: "/showcase/data-portals/government-of-yukon",
      description: "Government Open Data Portal",
    },
    {
      title: "World Resources Institute",
      image: "/assets/images/data-portals/wri/image1.jpg",
      href: "/showcase/data-portals/world-resources-institute",
      description: "Environmental Open Data Portal",
    },
    {
      title: "FIND (DxCONNECT)",
      image: "/assets/images/data-portals/find/image1.png",
      href: "/showcase/data-portals/find",
      description: "Global Health / NGO Open Data Portal",
    },
    {
      title: "IDPO",
      image: "/assets/images/data-portals/idpo/idpo1.png",
      href: "/showcase/data-portals/idpo",
      description: "Research Data Portal",
    },
    {
      title: "EDSN",
      image: "/assets/images/data-portals/edsn/image1.png",
      href: "/showcase/data-portals/edsn",
      description: "Energy Data Portal",
    },
  ]

  const morePortals = [
    {
      title: "Canada Open Data Portal",
      image: "/assets/images/data-portals/more/open-data-canada.webp",
      href: "https://open.canada.ca/en",
      description: "National Government Open Data Portal"
    },
    {
      title: "Panama Open Data",
      image: "/assets/images/data-portals/more/open-data-panama.webp",
      href: "https://www.datosabiertos.gob.pa",
      description: "National Government Open Data Portal"
    },
    {
      title: "Dundee City Council",
      image: "/assets/images/data-portals/more/dundee.webp",
      href: "https://data.dundeecity.gov.uk",
      description: "City Government Open Data Portal"
    },
    {
      title: "Los Angeles County",
      image: "/assets/images/data-portals/more/los-angeles-county.webp",
      href: "https://www.lacounts.org",
      description: "County Government Open Data Portal"
    },
    {
      title: "Open Data Portal Metropole Ruhr",
      image: "/assets/images/data-portals/more/metropole-ruhr.webp",
      href: "https://opendata.ruhr/en",
      description: "Regional Government Open Data Portal"
    },
    {
      title: "NextGEOSS",
      image: "/assets/images/data-portals/more/nextgeoss.webp",
      href: "https://catalogue.nextgeoss.eu",
      description: "Earth Observation and Environmental Open Data Portal"
    },
    {
      title: "New Mexico Water Data",
      image: "/assets/images/data-portals/more/new-mexico-water-data.webp",
      href: "https://catalog.newmexicowaterdata.org",
      description: "Water Resource Open Data Portal"
    },
    {
      title: "York",
      image: "/assets/images/data-portals/more/city-of-york-council.webp",
      href: "https://www.yorkopendata.org",
      description: "City Government Open Data Portal"
    },
    {
      title: "Stirling",
      image: "/assets/images/data-portals/more/stirling.webp",
      href: "https://data.stirling.gov.uk",
      description: "City Government Open Data Portal"
    },
    {
      title: "Perth & Kinross",
      image: "/assets/images/data-portals/more/perth-and-kinross.webp",
      href: "https://data.pkc.gov.uk",
      description: "County Government Open Data Portal"
    },
    {
      title: "Birmingham City Council",
      image: "/assets/images/data-portals/more/birmingham.png",
      href: "https://www.cityobservatory.birmingham.gov.uk/",
      description: "City Government Open Data Portal"
    },
    {
      title: "IAEA",
      image: "/assets/images/data-portals/more/iaea.png",
      href: "https://data.iaea.org",
      description: "International Atomic Energy Agency Data Portal"
    },
    {
      title: "Open Spending",
      image: "/assets/images/data-portals/more/openspending.png",
      href: "https://www.openspending.org/",
      description: "Public Financial Data Portal"
    },
    {
      title: "Datahub.io",
      image: "/assets/images/pages/showcase/datahub.webp",
      href: "https://datahub.io",
      description: "DataHub Cloud"
    },
    {
      title: "HateSpeechData",
      image: "/assets/images/data-portals/more/hatespeech.png",
      href: "https://turing.portaljs.org",
      description: "Social Research Data Portal"
    },
    {
      title: "FiveThirtyEight",
      image: "/assets/images/data-portals/more/fivethirtyeight.png",
      href: "https://fivethirtyeight.portaljs.org",
      description: "Data Journalism Portal"
    },
    {
      title: "EITI",
      description: "Transparency Data Portal",
      href: "https://eiti.portaljs.com/",
      image: "/assets/images/data-portals/more/eiti.webp",
    },
    {
      title: "London Borough of Hounslow",
      description: "Government Data Portal",
      href: "https://data.hounslow.gov.uk/",
      image: "/assets/images/data-portals/more/london.webp",
    },
    {
      title: "FIND",
      image: "/assets/images/layout/find.png",
      href: "https://finddx.portaljs.com",
      description: "Global Health and Diagnostics Data Portal"
    },
    {
      title: "Lincolnshire County Council",
      image: "/assets/images/data-portals/more/lincolnshire-city-council.png",
      href: "https://data.lincolnshire.gov.uk",
      description: "Local Government Open Data Portal"
    },
    {
      title: "Data for London (GLA)",
      image: "/assets/images/data-portals/more/data-for-london.jpg",
      href: "https://dfl.london.gov.uk/",
      description: "Regional Government Open Data Portal"
    },
    {
      title: "Sigma2 — NIRD Research Data Archive",
      image: "/assets/images/data-portals/more/sigma2.jpg",
      href: "https://archive.sigma2.no/",
      description: "National Research Data Archive"
    },
    {
      title: "Montreal City Data Portal",
      image: "/assets/images/data-portals/more/montreal.png",
      href: "https://donnees.montreal.ca/",
      description: "City Government Open Data Portal"
    },
    {
      title: "Republic of Azerbaijan",
      image: "/assets/images/data-portals/more/azerbaijan.png",
      href: "https://opendata.az/en",
      description: "Government Open Data Portal"
    },
    {
      title: "Royal Government of Bhutan",
      image: "/assets/images/data-portals/more/bhutan.jpg",
      href: "https://data.gov.bt/",
      description: "Government Open Data Portal"
    },
  ]


  return (
    <div className="lg:max-w-8xl mx-auto px-4 lg:px-8 mt-24 md:mt-16">
      <section className=" flex flex-col items-center ">
        <div tabIndex={0} className="flex flex-col gap-5 max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl items-center font-['Inter'] text-center px-4">
          <h2 className="main-top-title">Data portals we have built
          </h2>
          <h3 className="body-text">Some of our most extensive experience is with architecting complete data platforms, especially open data portals. Some of our major projects include:</h3>
          <p className="font-medium text-xl text-[#556987]"></p>
        </div>
      </section>
      <div className="medium-title text-left mt-4" tabIndex={0}>
        Featured Portals
      </div>
      <div className="my-12 grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
        {portals.map((item, index) => {
          return (
            <Link
              className="rounded overflow-hidden group relative border-1 shadow-lg w-full h-full"
              href={item.href}
              key={item.href}
              aria-labelledby={`descrp_${index}`}
            >
              <div
                className="bypass-filter bg-cover bg-no-repeat bg-top !aspect-[16/9] w-full h-full group-hover:blur-sm group-hover:scale-105 transition-all duration-200"
                style={{ backgroundImage: `url(${item.image})` }}
              >
                <div className="w-full h-full bg-black opacity-0 group-hover:opacity-50 transition-all duration-200"></div>
              </div>
              <div>
                <div className="opacity-0 group-hover:opacity-100 absolute top-0 bottom-0 right-0 left-0 transition-all duration-200 px-2 flex items-center justify-center">
                  <div className="text-center text-white">
                    <span className="text-xl font-semibold drop-shadow" id={`descrp_${index}`}>{item.title}</span>
                    <p className="text-base font-medium drop-shadow">{item.description}</p>
                  </div>
                </div>
              </div>
            </Link>
          )
        })}
      </div>
      <div className="medium-title text-left" tabIndex={0}>
        More Portals
      </div>
      <div className="my-12 grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
        {morePortals.reverse().map((item, index) => {
          return (
            <Link
              className="rounded overflow-hidden group relative border-1 shadow-lg w-full h-full"
              target="_blank"
              href={item.href}
              key={item.href}
              aria-labelledby={`descrp_${index}`}
            >
              <div
                className="bg-cover bg-no-repeat bg-top !aspect-[16/9] w-full h-full group-hover:blur-sm group-hover:scale-105 transition-all duration-200"
                style={{ backgroundImage: `url(${item.image})` }}
              >
                <div className="w-full h-full bg-black opacity-0 group-hover:opacity-50 transition-all duration-200"></div>
              </div>
              <div>
                <div className="opacity-0 group-hover:opacity-100 absolute top-0 bottom-0 right-0 left-0 transition-all duration-200 px-2 flex items-center justify-center">
                  <div className="text-center text-white">
                    <span className="text-xl font-semibold drop-shadow" id={`descrp_${index}`}>{item.title}</span>
                    <p className="text-base font-medium drop-shadow">{item.description}</p>
                  </div>
                </div>
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

